<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="450px"
    :colon="true"
    label-width="80px"
    data-automation="addUser"
  >
    <ux-form-item :label="$t('HT.amsRelation.name')" prop="code">
      <ux-input v-model.trim()="formData.code" :placeholder="$t('HT.amsRelation.placeholder')"></ux-input>
    </ux-form-item>
  </ux-form>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          code: '' // 用户名
        };
      }
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.amsCus()
    };
  },
  watch: {
    data: {
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  }
};
</script>
